<template>
  <div>
    <v-container v-if="userDataLoaded" grid-list-md fluid class="ma-0 pa-1">
      
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex v-if="userCompanies.length > 1 && !demoMode" :class="filterGridClass" xs12>
          <v-select
            class="ma-1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="name"
            item-value="id"
            v-model="dataFilter.activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            v-on:input="loadBranches()"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex v-if="branches.length > 0" :class="filterGridClass" xs12>
          <v-select
            class="ma-1"
            :items="branches"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            item-text="branchName"
            item-value="id"
            v-model="dataFilter.selectedBranch"
            no-data-text="Geen vestigingen gevonden."
            label="Selecteer vestiging"
            outlined
            hide-details
            dense>
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex :class="filterGridClass" xs12>
          <v-select
            class="mt-1"
            outlined
            dense
            :color="companyPrimaryColor"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"    
            :items="photoStatusOptions"
            item-text="name"
            item-value="id"
            v-model="dataFilter.photoStatus"
            label="Selecteer weergave"
            hide-details
          ></v-select>
        </v-flex>
        <v-flex :class="filterGridClass" xs12>
          <v-menu
            style="z-index: 99;"
            ref="menu"
            v-model="menu"
            :nudge-right="40"
            max-width="290"
            offset-y
            :color="companyPrimaryColor"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mt-1"
                outlined
                dense
                :color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"    
                v-model="chosenDateCalendarFormated"
                label="Maand"
                prepend-inner-icon="event"
                readonly
                v-on="on"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              style="z-index: 99;"
              v-model="dataFilter.chosenDateCalendar"
              :color="companyPrimaryColor"
              :max="max"
              no-title
              type="month"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex :class="filterGridClass" xs12>
          <v-btn
            class="mt-1"
            height="40px"
            block
            :depressed="loading"
            :disabled="filterChanged"
            :color="companyPrimaryColor"
            @click="loadClientPhotos()"
          >
            <span style="color: #fff;">Filteren</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <div class="blackbox-loader" v-if="loading == true "></div>

    <div class="no-salon-data" v-if="loading == false && HogansDataCustomer.length == 0 && !loadingError">
      <p>Geen foto's gevonden.</p>
    </div>

    <div class="no-salon-data" v-if="loading == false && loadingError">
      <p>Er is iets misgegaan met ophalen van de foto's. Probeer opnieuw.</p>
    </div>

    <div v-if="loading == false && HogansDataCustomerSorted.length > 0 && !loadingError">
      <v-container grid-list-md fluid class="my-3 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex sm6 md3>
            <v-card outlined class="usertype-total">
              <div class="usertype-total-number">{{ filteredFotos }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredFotos == 1">Klant met foto's</span>
                <span v-else>Klanten met foto's</span>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm6 md3>
            <v-card outlined class="usertype-total">
              <div class="usertype-total-number">{{ filteredFotosBefore }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredFotosBefore == 1">Klant met <i>Beforefoto's</i></span>
                <span v-else>Klanten met <i>Beforefoto's</i></span>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm6 md3>
            <v-card outlined class="usertype-total">
              <div class="usertype-total-number">{{ filteredFotosAfter }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredFotosAfter== 1">Klanten <i>Afterfoto's</i></span>
                <span v-else>Klanten met <i>Afterfoto's</i></span>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm6 md3>
            <v-card outlined class="usertype-total">
              <div class="usertype-total-number">{{ filteredFotosPosted }}</div>
              <div class="usertype-total-desc">
                <span v-if="filteredFotosPosted == 1">Foto gepost</span>
                <span v-else>Foto's gepost</span>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>


      <div class="text-xs-center pt-2" v-if="HogansDataCustomerSorted.length > 15">
        <v-pagination v-model="photoResultsPage" circle :color="companyPrimaryColor" :length="photoPageCountResults" :total-visible="10"></v-pagination>
      </div>

      <div class="photo-collection-wrapper" v-for="(photos, index) in HogansDataCustomerSortedPages" :key="index">
        <v-card outlined style="max-width: 1100px;">
          <v-container fluid class="ma-0 pa-2" grid-list-md>

            <!-- Before Photos -->
            <v-layout row wrap v-if="photos.photoCollectionBefore != null">
              <v-flex xs3 class="photobox" v-if="photos.photoCollectionBefore">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmediaBefore.front == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionBefore', 'front')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmediaBefore.front == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollectionBefore.front, photos.customerName + '_front.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollectionBefore.front"
                  >
                    <v-container fill-height fluid pa-2>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="BeforeAfter">Before</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'front', 'before')"
                  v-model="photos.mailingBefore.front"
                  :label="photos.mailingBefore.front ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionBefore.side">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmediaBefore.side == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionBefore', 'side')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmediaBefore.side == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollectionBefore.side, photos.customerName + '_side.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollectionBefore.side"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'side', 'before')"
                  v-model="photos.mailingBefore.side"
                  :label="photos.mailingBefore.side ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionBefore.back">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmediaBefore.back == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionBefore', 'back')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmediaBefore.back == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollectionBefore.back, photos.customerName + '_back.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollectionBefore.back"
                  > 
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'back', 'before')"
                  v-model="photos.mailingBefore.back"
                  :label="photos.mailingBefore.back ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionBefore.extra">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmediaBefore.extra == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionBefore', 'extra')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmediaBefore.extra == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollectionBefore.extra, photos.customerName + '_extra.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollectionBefore.extra"
                  > 
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra', 'before')"
                  v-model="photos.mailingBefore.extra"
                  :label="photos.mailingBefore.extra ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionBefore.extra2">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmediaBefore.extra2 == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionBefore', 'extra2')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmediaBefore.extra2 == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollectionBefore.extra2, photos.customerName + '_extra2.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollectionBefore.extra2"
                  > 
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra2', 'before')"
                  v-model="photos.mailingBefore.extra2"
                  :label="photos.mailingBefore.extra2 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionBefore.extra3">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmediaBefore.extra3 == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionBefore', 'extra3')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmediaBefore.extra3 == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollectionBefore.extra3, photos.customerName + '_extra3.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollectionBefore.extra3"
                  > 
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra3', 'before')"
                  v-model="photos.mailingBefore.extra3"
                  :label="photos.mailingBefore.extra3 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

            </v-layout>

            <!-- After Photos -->
            <v-layout row wrap v-if="photos.photoCollection">
              
              <v-flex xs3 class="photobox" v-if="photos.photoCollection.front">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmedia.front == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollection', 'front')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>
                  <div class="download" v-if="photos.socialmedia.front == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollection.front, photos.customerName + '_front.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollection.front"
                  >
                    <v-container fill-height fluid pa-2>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="BeforeAfter">After</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'front', 'after')"
                  v-model="photos.mailingAfter.front"
                  :label="photos.mailingAfter.front ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollection.side">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmedia.side == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollection', 'side')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmedia.side == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollection.side, photos.customerName + 'side.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollection.side"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'side', 'after')"
                  v-model="photos.mailingAfter.side"
                  :label="photos.mailingAfter.side ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollection.back">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmedia.back == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollection', 'back')"  color="#000" small class="individual-remove-photo" >
                <v-icon color="white" >mdi-delete</v-icon>
              </v-btn>
                  <div class="download" v-if="photos.socialmedia.back == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollection.back, photos.customerName + 'back.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollection.back"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'back', 'after')"
                  v-model="photos.mailingAfter.back"
                  :label="photos.mailingAfter.back ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollection.extra">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmedia.extra == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>
                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollection', 'extra')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>
                  <div class="download" v-if="photos.socialmedia.extra == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollection.extra, photos.customerName + 'extra.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollection.extra"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra', 'after')"
                  v-model="photos.mailingAfter.extra"
                  :label="photos.mailingAfter.extra ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollection.extra2">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmedia.extra2 == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollection', 'extra2')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmedia.extra2 == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                        @click="downloadPhoto(photos.photoCollection.extra2, photos.customerName + 'extra2.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollection.extra2"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra2', 'after')"
                  v-model="photos.mailingAfter.extra2"
                  :label="photos.mailingAfter.extra2 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollection.extra3">
                <div class="photobox">
                  <v-tooltip right style="z-index: 9;">
                    <template v-slot:activator="{on}">
                      <div
                        v-on="on"
                        :style="`background-color: ${companyPrimaryColor};`"
                        class="socialapproved"
                        v-if="photos.socialmedia.extra3 == true"
                      ></div>
                    </template>
                    <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                  </v-tooltip>

                  <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollection', 'extra3')"  color="#000" small class="individual-remove-photo" >
                    <v-icon color="white" >mdi-delete</v-icon>
                  </v-btn>

                  <div class="download" v-if="photos.socialmedia.extra3 == true && userRole !== 'employee'">
                    <div class="download-overlay text-xs-center" >
                      <v-btn
                      @click="downloadPhoto(photos.photoCollection.extra3, photos.customerName + 'extra3.jpg' )"
                        :color="companyPrimaryColor"
                        dark
                        class="photo-download-button"
                      >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                    </div>
                  </div>

                  <v-img
                    class="grey lighten-2"
                    :aspect-ratio="3/3.6"
                    position="center top"
                    :src="photos.photoCollection.extra3"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra3', 'after')"
                  v-model="photos.mailingAfter.extra3"
                  :label="photos.mailingAfter.extra3 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

            </v-layout>

            <!-- Controle Photos -->
            <v-layout row wrap v-if="photos.photoCollectionCheckup">
              <v-tooltip right style="z-index: 9;">
                <template v-slot:activator="{on}">
                  <div
                    v-on="on"
                    :style="`background-color: ${companyPrimaryColor};`"
                    class="socialapproved"
                    v-if="photos.socialmedia.front == true"
                  ></div>
                </template>
                <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
              </v-tooltip>

              <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'front')"  color="#000" small class="individual-remove-photo" >
                <v-icon color="white" >mdi-delete</v-icon>
              </v-btn>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckup.front">
                <div class="photobox">
                <div class="download" v-if="photos.socialmedia.front == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckup.front, photos.customerName + '_front.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckup.front"
                >
                  <v-container fill-height fluid pa-2>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span class="BeforeAfter">Controle</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'front', 'checkup')"
                  v-model="photos.mailingCheckup.front"
                  :label="photos.mailingCheckup.front ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckup.side">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.side == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'side')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>

                <div class="download" v-if="photos.socialmedia.side == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckup.side, photos.customerName + 'side.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckup.side"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'side', 'checkup')"
                  v-model="photos.mailingCheckup.side"
                  :label="photos.mailingCheckup.side ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckup.back">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.back == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'back')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>

                <div class="download" v-if="photos.socialmedia.back == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckup.back, photos.customerName + 'back.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckup.back"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'back', 'checkup')"
                  v-model="photos.mailingCheckup.back"
                  :label="photos.mailingCheckup.back ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckup.extra">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.extra == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'extra')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>


                <div class="download" v-if="photos.socialmedia.extra == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckup.extra, photos.customerName + 'extra.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckup.extra"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra', 'checkup')"
                  v-model="photos.mailingCheckup.extra"
                  :label="photos.mailingCheckup.extra ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckup.extra2">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.extra2 == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'extra2')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>

                <div class="download" v-if="photos.socialmedia.extra2 == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckup.extra2, photos.customerName + 'extra2.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckup.extra2"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra2', 'checkup')"
                  v-model="photos.mailingCheckup.extra2"
                  :label="photos.mailingCheckup.extra2 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckup.extra3">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.extra3 == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'extra3')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>
                <div class="download" v-if="photos.socialmedia.extra3 == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center">
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckup.extra3, photos.customerName + 'extra3.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckup.extra3"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra3', 'checkup')"
                  v-model="photos.mailingCheckup.extra3"
                  :label="photos.mailingCheckup.extra3 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

            </v-layout>

            <!-- Controle Photos Two (Extra) -->
            <v-layout row wrap v-if="photos.photoCollectionCheckupTwo">
              <v-tooltip right style="z-index: 9;">
                <template v-slot:activator="{on}">
                  <div
                    v-on="on"
                    :style="`background-color: ${companyPrimaryColor};`"
                    class="socialapproved"
                    v-if="photos.socialmedia.front == true"
                  ></div>
                </template>
                <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
              </v-tooltip>

              <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'front')"  color="#000" small class="individual-remove-photo" >
                <v-icon color="white" >mdi-delete</v-icon>
              </v-btn>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckupTwo.front">
                <div class="photobox">
                <div class="download" v-if="photos.socialmedia.front == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckupTwo.front, photos.customerName + '_front.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckupTwo.front"
                >
                  <v-container fill-height fluid pa-2>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span class="BeforeAfter">Controle</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'front', 'checkup')"
                  v-model="photos.mailingCheckup.front"
                  :label="photos.mailingCheckup.front ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckupTwo.side">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.side == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'side')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>

                <div class="download" v-if="photos.socialmedia.side == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckupTwo.side, photos.customerName + 'side.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckupTwo.side"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'side', 'checkup')"
                  v-model="photos.mailingCheckup.side"
                  :label="photos.mailingCheckup.side ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckupTwo.back">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.back == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'back')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>

                <div class="download" v-if="photos.socialmedia.back == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckupTwo.back, photos.customerName + 'back.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckupTwo.back"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'back', 'checkup')"
                  v-model="photos.mailingCheckup.back"
                  :label="photos.mailingCheckup.back ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckupTwo.extra">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.extra == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'extra')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>


                <div class="download" v-if="photos.socialmedia.extra == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckupTwo.extra, photos.customerName + 'extra.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckupTwo.extra"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra', 'checkup')"
                  v-model="photos.mailingCheckup.extra"
                  :label="photos.mailingCheckup.extra ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckupTwo.extra2">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.extra2 == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'extra2')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>

                <div class="download" v-if="photos.socialmedia.extra2 == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center" >
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckupTwo.extra2, photos.customerName + 'extra2.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckupTwo.extra2"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra2', 'checkup')"
                  v-model="photos.mailingCheckup.extra2"
                  :label="photos.mailingCheckup.extra2 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

              <v-flex xs3 class="photobox" v-if="photos.photoCollectionCheckupTwo.extra3">
                <div class="photobox">
                <v-tooltip right style="z-index: 9;">
                  <template v-slot:activator="{on}">
                    <div
                      v-on="on"
                      :style="`background-color: ${companyPrimaryColor};`"
                      class="socialapproved"
                      v-if="photos.socialmedia.extra3 == true"
                    ></div>
                  </template>
                  <span style="color: #fff;">Deze foto mag gedeeld worden.</span>
                </v-tooltip>

                <v-btn v-if="userRole == 'superadmin' || userRole == 'admin' || userRole == 'manager'" fab @click="deleteIndividualPhoto(photos, 'photoCollectionCheckup', 'extra3')"  color="#000" small class="individual-remove-photo" >
                  <v-icon color="white" >mdi-delete</v-icon>
                </v-btn>
                <div class="download" v-if="photos.socialmedia.extra3 == true && userRole !== 'employee'">
                  <div class="download-overlay text-xs-center">
                    <v-btn
                      @click="downloadPhoto(photos.photoCollectionCheckupTwo.extra3, photos.customerName + 'extra3.jpg' )"
                      :color="companyPrimaryColor"
                      dark
                      class="photo-download-button"
                    >Download<v-icon right dark>cloud_download</v-icon></v-btn>
                  </div>
                </div>

                <v-img
                  class="grey lighten-2"
                  :aspect-ratio="3/3.6"
                  position="center top"
                  :src="photos.photoCollectionCheckupTwo.extra3"
                >
                  <template v-slot:placeholder>
                    <v-layout fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
                </div>
                <v-switch
                  v-if="dataFilter.activeComp == 'beautybyroos'"
                  @change="setMailing(photos, 'extra3', 'checkup')"
                  v-model="photos.mailingCheckup.extra3"
                  :label="photos.mailingCheckup.extra3 ? 'Gebruiken in mailing' : `Niet gebruiken in mailing`"
                ></v-switch>
              </v-flex>

            </v-layout>
          </v-container>

          <v-container fill-height fluid pa-2>
            <v-layout fill-height>
              <v-flex md6 xs12 >
                <div class="photoinfo">
                  <span class="title" :style="{color: $vuetify.theme.themes[theme].text}" v-text="photos.customerName"></span><br>
                  <span class="photodate subheading date" :style="{color: $vuetify.theme.themes[theme].text}">
                    {{photos.datePhoto | moment('D MMMM YYYY - HH:mm')}}u door
                    <strong>{{photos.employee}}</strong> ({{ photos.branchName }})
                  </span>
                </div>
              </v-flex>
              <v-flex md6 xs12>
                <div v-if="dataFilterSaved.activeComp == 'beautybyroos'" class="pa-0 ma-0 pr-3" style="float:left;">
                  <v-switch
                    :color="companyPrimaryColor"
                    :label="mailingCheckUpStatus(photos)"
                    hide-details
                    v-model="photos.mailingCheckUpDone"
                    @change="updateMauticPhotos(photos)"
                  ></v-switch>
                </div>
                <div class="pa-0 ma-0" style="float:left;">
                  <v-switch
                    :color="companyPrimaryColor"
                    :label="socialStatusPhotos(photos.socialposted)"
                    :disabled="socialStatus"
                    hide-details
                    v-model="photos.socialposted"
                    @change="SendPosted(photos.socialposted, photos.id)"
                  ></v-switch>
                </div>

                <div style="float:right;" v-if="userRole == 'superadmin'" class="actionbuttons">
                  <v-tooltip top style="z-index: 9;">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" fab dark small :color="companyPrimaryColor" class="pa-0 ma-2" @click="downloadAllPhotos(index)">
                        <v-icon dark>cloud_download</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: #fff;">Download alle foto's met toestemming</span>
                  </v-tooltip>

                  <v-btn fab dark @click="deletePhoto(photos.id)" small :color="companyPrimaryColor" class="pa-0 ma-2" style="margin-right: 6px!important;">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </div>

              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </div>

      <div class="text-xs-center pt-2" v-if="HogansDataCustomerSorted.length > 15">
        <v-pagination v-model="photoResultsPage" circle :color="companyPrimaryColor" :length="photoPageCountResults" :total-visible="10"></v-pagination>
      </div>

    </div>
          
  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "@/firebase/init";
import moment from "moment";
import lodash from "lodash";
import axios from "axios";

export default {
  name: "Photowall",
  data() {
    return {
      HogansDataCustomer: [],
      HogansDataCustomerBefore: [], //Before fotos
      searchCompanies:"",
      activeCompData: null,
      menu: false,
      branches: new Array(),
      
      filterPosted: "showAll",
      companies: [],
      loading: null,
      loadingError: null,
      userDataLoaded: false,
      min: null,
      max: null,
      dataFilter: {
        activeComp: null,
        photoStatus: "showAll",
        selectedBranch: null,
        chosenDateCalendar: moment().format("YYYY-MM")
      },
      photoResultsPage: 1,

      dataFilterSaved: {
        
      },
      photoStatusOptions: [
        {
          name: "Alle",
          id: "showAll"
        },
        {
          name: "Gepost",
          id: "posted"
        },
        {
          name: "Niet gepost",
          id: "notposted"
        },
      ]

    };
  },
  created() {
    this.loadUserComp();
    this.max = moment().format("YYYY-MM")
  },

  methods: {

    loadUserComp() {
      this.loading == true;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.dataFilter.activeComp = this.companies[selectedCompanyIndex].id;
              // console.log("selectedCompanyIndex: ", selectedCompanyIndex)
              this.userDataLoaded = true;
              this.loadBranches()
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.dataFilter.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.userDataLoaded = true;
              this.loadBranches()
            }
          }
          // No selected company is set 
          else {
            this.dataFilter.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.userDataLoaded = true;
            this.loadBranches()
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.dataFilter.activeComp = this.companies[0].id;
          this.userDataLoaded = true;
          this.loadBranches()
        }
      })
    },

    loadBranches() {
      this.loading = false;
      window.localStorage.setItem('selectedCompany', this.activeComp)
      this.branches = [];
      

      this.companies.forEach(data => {
        if (data.id == this.dataFilter.activeComp) {
          this.activeCompData = data;
        }
      });

      // Load branches
      this.branches = [];
      this.selectedBranches = [];
      this.branches.push({
        id: 'all',
        branchName: "Alle vestigingen"
      })
      this.dataFilter.selectedBranch = 'all';

      if (this.userRole == "employee" || this.userRole == "manager") {
        if (this.userBranches.length > 0) {
          this.selectedBranches = this.userBranches;
          let branchCounter = 0;
          new Promise((resolve, reject) => {
            this.selectedBranches.forEach(branch => {
              db.collection("branches")
                .doc(branch)
                .get()
                .then(doc => {
                  let branchCollection = doc.data();
                  branchCollection.id = doc.id;
                  this.branches.push(branchCollection);
                })
                .then(() => {
                  branchCounter++;
                  if (branchCounter == this.selectedBranches.length) {
                    resolve();
                  }
                });
            });
          })
          .then(() => {
            this.selectedBranch = this.branches[0].id;
            this.loadselectedBranchData();
          });
        } 
        else {
          this.userDataLoaded = true;
          this.dataloaded = true;
          this.noData = true;
        }
      }
      else {
        db.collection("branches")
          .where("compId", "==", this.dataFilter.activeComp)
          .get()
          .then(snap => {
            snap.forEach(doc => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.branches.push(branchCollection);
              this.selectedBranches.push(doc.id);
              // this.selectedBranchesSalonhub.push(doc.data().branchNameSalonhub);
            });
          })
          .then(() => {
            this.selectedBranch = this.branches[0].id;
            this.loadselectedBranchData();
          });
      }
    },

    loadselectedBranchData() {
      this.dataloaded = false;
      this.selectedBranchData = {};
      if (this.dataFilter.selectedBranch) {
        db.collection("branches")
          .doc(this.selectedBranch)
          .get()
          .then(doc => {
            this.selectedBranchData = doc.data();
          })
          .then(() => {
            this.noData = false;
            this.userDataLoaded = true;
            this.loadClientPhotos();
          });
      } else {
        this.userDataLoaded = true;
        this.dataloaded = true;
        this.noData = true;
      }

       

    },

    async updateMauticPhotos(photos){
      // console.log("photos: ", photos)

      let afterphoto1 = " ";
      let afterphoto2 = " ";
      let afterphoto3 = " ";
      let afterphoto4 = " ";
      let afterphoto5 = " ";
      let afterphoto6 = " ";
      let afterphoto7 = " ";
      let afterphoto8 = " ";
      let afterphoto9 = " ";
      let afterphoto10 = " ";
      let afterphoto11 = " ";
      let afterphoto12 = " ";
      let photosupdated = "2000-01-01";

      // Are photo's check or not checked?

      await new Promise((resolve)=>{
        if(photos.mailingCheckUpDone){ // Checked

          console.log("Foto's gecontroleerd")
          // After Photo's
          if(photos.photoCollection && photos.mailingAfter){ // After photo's found 
            // console.log("After photo's aanwezig")

            let afterPhotos = new Array();
            
            // Before Photo's
            if(photos.photoCollectionBefore && photos.mailingBefore){ // Before photo's found 
              // console.log("Before photo's aanwezig")
              if(photos.mailingBefore.front && photos.photoCollectionBefore.front){
                afterPhotos.push(photos.photoCollectionBefore.front)
              }
              if(photos.mailingBefore.back && photos.photoCollectionBefore.back){
                afterPhotos.push(photos.photoCollectionBefore.back)
              }
              if(photos.mailingBefore.side && photos.photoCollectionBefore.side){
                afterPhotos.push(photos.photoCollectionBefore.side)
              }
              if(photos.mailingBefore.extra && photos.photoCollectionBefore.extra){
                afterPhotos.push(photos.photoCollectionBefore.extra)
              }
              if(photos.mailingBefore.extra1 && photos.photoCollectionBefore.extra1){
                afterPhotos.push(photos.photoCollectionBefore.extra1)
              }
              if(photos.mailingBefore.extra2 && photos.photoCollectionBefore.extra2){
                afterPhotos.push(photos.photoCollectionBefore.extra2)
              }
              if(photos.mailingBefore.extra3 && photos.photoCollectionBefore.extra3){
                afterPhotos.push(photos.photoCollectionBefore.extra3)
              }
            }

            if(photos.mailingAfter.front && photos.photoCollection.front){
              afterPhotos.push(photos.photoCollection.front)
            }
            if(photos.mailingAfter.back && photos.photoCollection.back){
              afterPhotos.push(photos.photoCollection.back)
            }
            if(photos.mailingAfter.side && photos.photoCollection.side){
              afterPhotos.push(photos.photoCollection.side)
            }
            if(photos.mailingAfter.extra && photos.photoCollection.extra){
              afterPhotos.push(photos.photoCollection.extra)
            }
            if(photos.mailingAfter.extra1 && photos.photoCollection.extra1){
              afterPhotos.push(photos.photoCollection.extra1)
            }
            if(photos.mailingAfter.extra2 && photos.photoCollection.extra2){
              afterPhotos.push(photos.photoCollection.extra2)
            }
            if(photos.mailingAfter.extra3 && photos.photoCollection.extra3){
              afterPhotos.push(photos.photoCollection.extra3)
            }

            // Prepare Fields
            afterphoto1 = afterPhotos[0] ? afterPhotos[0] : " ";
            afterphoto2 = afterPhotos[1] ? afterPhotos[1] : " ";
            afterphoto3 = afterPhotos[2] ? afterPhotos[2] : " ";
            afterphoto4 = afterPhotos[3] ? afterPhotos[3] : " ";
            afterphoto5 = afterPhotos[4] ? afterPhotos[4] : " ";
            afterphoto6 = afterPhotos[5] ? afterPhotos[5] : " ";
            afterphoto7 = afterPhotos[6] ? afterPhotos[6] : " ";
            afterphoto8 = afterPhotos[7] ? afterPhotos[7] : " ";
            afterphoto9 = afterPhotos[8] ? afterPhotos[8] : " ";
            afterphoto10 = afterPhotos[9] ? afterPhotos[9] : " ";
            afterphoto11 = afterPhotos[10] ? afterPhotos[10] : " ";
            afterphoto12 = afterPhotos[11] ? afterPhotos[11] : " ";
            resolve()
          }

          else{ // No after photo's
            console.log("Geen after photo's aanwezig")
            resolve()
          }
          photosupdated = moment().format("YYYY-MM-DD")
        }
        else{ // Not checked
          console.log("Foto's niet gecontroleerd")
          resolve()
        }
      })

      let data = {
        salonhubid: photos.salonhub_ID,
        afterphoto1: afterphoto1,
        afterphoto2: afterphoto2,
        afterphoto3: afterphoto3,
        afterphoto4: afterphoto4,
        afterphoto5: afterphoto5,
        afterphoto6: afterphoto6,
        afterphoto7: afterphoto7,
        afterphoto8: afterphoto8,
        afterphoto9: afterphoto9,
        afterphoto10: afterphoto10,
        afterphoto11: afterphoto11,
        afterphoto12: afterphoto12,
        photosupdated: photosupdated
      }

      // console.log("mauticdata: ", data)

      // Post Fields to Client

      const username = "apiUser";
      const password = "bTF8w6haXbuNcqJ6aWNmy!KAJH4";
      const token = Buffer.from(`${username}:${password}`, "utf8").toString("base64");

      let configAxiosPOST = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
      };

      await axios
        .post(
          `https://beautybyroos.hogans.nl/api/contacts/new`,
          data,
          configAxiosPOST,
          { timeout: 5000 }
        )
        .then((response) => {
          console.log(
            response.data.contact.id,
            " => stored to Mautic"
          );
        })
        .catch((error) => {
          console.error(
            "Error import: ",
            error
          );
        });

      db.collection("clientphotos").doc(photos.id)
      .update({
        mailingCheckUpDone: photos.mailingCheckUpDone
      })
      .catch(error => {
        // The document probably doesn't exist.
        console.error("Error updating mailingCheckUpDone: ", error);
      });  


    },
 

    SendPosted(bool, clientphotoID) {
      //Check socialmedia

      db.collection("clientphotos")
      .doc(clientphotoID)
      .update({
        socialposted: bool
      })
      .then(() => {
        console.log("Updated posted with:", bool);
      })
      .catch(error => {
        // The document probably doesn't exist.
        console.error("Error updating posted: ", error);
      });
    },

    setMailing(photos, type, photoType){
      let id = null;
      let mailing = null;
      if(photoType == 'before'){
        id = photos.beforeId;
        mailing = photos.mailingBefore;
        console.log("setMailing", type, photoType, id)
      }
      else if(photoType == 'after'){
        id = photos.id;
        mailing = photos.mailingAfter;
        console.log("setMailing", type, photoType, id)
      }
      else if(photoType == 'checkup'){
        id = photos.checkupId;
        mailing = photos.mailingCheckup;
        console.log("setMailing", type, photoType, id)
      }

      

      if(id && mailing){
        db.collection("clientphotos")
          .doc(id)
          .set({
            mailing: mailing
          },{merge: true})
          .then(() => {
            console.log("Updated Clientphotos with:", mailing);
          })
          .catch(error => {
            // The document probably doesn't exist.
            console.error("Error updating setMailing Clientphotos: ", error);
          });
      }

      



      console.log("setMailing:", photos, type)
    },

    downloadPhoto(uri, name) {
      console.log(uri, name);

      //uri Firebase path, name filename
      axios({
        url: uri,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", name); //or any other extension
        document.body.appendChild(link);
        link.click();
      });

      // FileSaver.saveAs(
      //   "https://firebasestorage.googleapis.com/v0/b/clientphotos/o/hairbeautycompany%2Fcrop_development_clientid_20909_1joojd2vh_side.jpg?alt=media&token=",
      //   "image.jpg"
      // );
      // var link = document.createElement("a");
      // link.download = name;
      // link.target = "_blank";
      // link.href = uri;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },

    downloadAllPhotos(index) {

      let downloadQueue = []

      new Promise((resolve, reject)=>{
        let counter = 0
        if(this.HogansDataCustomerSortedPages[index].photoCollection){
          if(this.HogansDataCustomerSortedPages[index].photoCollection.front){
            if(this.HogansDataCustomerSortedPages[index].socialmedia.front || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollection.front,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'front.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollection.back){
            if(this.HogansDataCustomerSortedPages[index].socialmedia.back || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollection.back,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'back.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollection.side){
            if(this.HogansDataCustomerSortedPages[index].socialmedia.side || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollection.side,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'side.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollection.extra){
            if(this.HogansDataCustomerSortedPages[index].socialmedia.extra || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollection.extra,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } 
            else {
              counter++
            }
          } 
          if(this.HogansDataCustomerSortedPages[index].photoCollection.extra2){
            if(this.HogansDataCustomerSortedPages[index].socialmedia.extra2 || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollection.extra2,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra2.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } 
            else {
              counter++
            }
          } 
          if(this.HogansDataCustomerSortedPages[index].photoCollection.extra3){
            if(this.HogansDataCustomerSortedPages[index].socialmedia.extra3 || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollection.extra3,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra3.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } 
            else {
              counter++
            }
          } 
          else {
            counter++
          }
        } else {
          counter = counter + 6
          if(counter == 18){
            resolve()
          }
        }

        if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore){
          if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore.front){
            if(this.HogansDataCustomerSortedPages[index].socialmediaBefore.front  || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionBefore.front,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'front.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore.back){
            if(this.HogansDataCustomerSortedPages[index].socialmediaBefore.back || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionBefore.back,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'back.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore.side){
            if(this.HogansDataCustomerSortedPages[index].socialmediaBefore.side || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionBefore.side,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'side.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } 
          else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore.extra){
            if(this.HogansDataCustomerSortedPages[index].socialmediaBefore.extra  || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionBefore.extra,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
              if(counter == 18){
                resolve()
              }
            }
            else {
              counter++
              if(counter == 18){
                resolve()
              }
            }
          }
          else {
            counter++
          }

          if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore.extra2){
            if(this.HogansDataCustomerSortedPages[index].socialmediaBefore.extra2 || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionBefore.extra2,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra2.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
              if(counter == 8){
                resolve()
              }
            }
            else {
              counter++
              if(counter == 18){
                resolve()
              }
            }
          }
          else {
            counter++
          }

          if(this.HogansDataCustomerSortedPages[index].photoCollectionBefore.extra3){
            if(this.HogansDataCustomerSortedPages[index].socialmediaBefore.extra3 || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionBefore.extra3,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra3.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
              if(counter == 18){
                resolve()
              }
            }
            else {
              counter++
              if(counter == 18){
                resolve()
              }
            }
          }
          else {
            counter++
            if(counter == 18){
              resolve()
            }
          }
        }
        else {
          counter = counter + 6
          if(counter == 18){
            resolve()
          }
        }
        if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup){
          if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.front){
            if(this.HogansDataCustomerSortedPages[index].socialmediaCheckup.front || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.front,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'front.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.back){
            if(this.HogansDataCustomerSortedPages[index].socialmediaCheckup.back || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.back,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'back.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.side){
            if(this.HogansDataCustomerSortedPages[index].socialmediaCheckup.side || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.side,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'side.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
            } else {
              counter++
            }
          } 
          else {
            counter++
          }
          if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.extra){
            if(this.HogansDataCustomerSortedPages[index].socialmediaCheckup.extra || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.extra,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
              if(counter == 18){
                resolve()
              }
            }
            else {
              counter++
              if(counter == 18){
                resolve()
              }
            }
          }
          else {
            counter++
          }

          if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.extra2){
            if(this.HogansDataCustomerSortedPages[index].socialmediaCheckup.extra2 || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.extra2,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra2.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
              if(counter == 8){
                resolve()
              }
            }
            else {
              counter++
              if(counter == 18){
                resolve()
              }
            }
          }
          else {
            counter++
          }

          if(this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.extra3){
            if(this.HogansDataCustomerSortedPages[index].socialmediaCheckup.extra3 || this.userRole == 'admin'  || this.userRole == 'superadmin'){
              let downloadItem = {
                uri: this.HogansDataCustomerSortedPages[index].photoCollectionCheckup.extra3,
                name: this.HogansDataCustomerSortedPages[index].customerName + 'extra3.jpg' 
              }
              downloadQueue.push(downloadItem)
              counter++
              if(counter == 18){
                resolve()
              }
            }
            else {
              counter++
              if(counter == 18){
                resolve()
              }
            }
          }


          else {
            counter++
            if(counter == 18){
              resolve()
            }
          }
        }
        else {
          counter = counter + 6
          if(counter == 18){
            resolve()
          }
        }
      })
      .then(()=>{
        downloadQueue.forEach(downloadItem=>{
          axios({
            url: downloadItem.uri,
            method: "GET",
            responseType: "blob" // important
          }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", downloadItem.name); //or any other extension
            document.body.appendChild(link);
            link.click();
          });
        })
      })
    },

    loadClientPhotos() {
      this.photoResultsPage = 1;
      // Foto's van de geselecteerde company binnenladen

      // Inladen fotos bij het opstarten van de Photowall
      window.localStorage.setItem('selectedCompany', this.dataFilter.activeComp)
      this.dataFilterSaved = _.cloneDeep(this.dataFilter)
      this.HogansDataCustomer = [];
      this.HogansDataCustomerBefore = [];
      this.loading = true;

      //console.log("moment().isoWeekday(1)", moment().isoWeekday(1));
      //console.log("Start: ", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
      //console.log("Einde: ", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
       
      if (this.filterPosted == "showAll") {
        let allDataAfter = db.collection("clientphotos")
          .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
          .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
          .where("company", "==", this.dataFilter.activeComp)     
          .where("photoBA", "==", 1)
          .orderBy("datePhoto", "asc");
        let branchDataAfter = db.collection("clientphotos")
            .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
            .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
            .where("company", "==", this.dataFilter.activeComp)     
            .where("photoBA", "==", 1)
            .where("branch", "==", this.dataFilter.selectedBranch)
            .orderBy("datePhoto", "asc");
        let branchFilterAfter = this.dataFilter.selectedBranch == 'all' ? allDataAfter : branchDataAfter;


        // Alle after foto's binnenhalen
          branchFilterAfter.get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let clientPhoto = doc.data()
              clientPhoto.id = doc.id
              clientPhoto.photoCollectionCheckup = null;
              clientPhoto.photoCollectionCheckupTwo = null;
              clientPhoto.photoCollectionBefore = null;
              clientPhoto.socialmediaBefore = null;
              clientPhoto.socialmediaCheckup = null;
              if(clientPhoto.mailing){
                clientPhoto.mailingAfter = clientPhoto.mailing;
              }
              else{
                clientPhoto.mailingAfter = {
                  front: false,
                  side: false,
                  back: false,
                  extra: false,
                  extra2: false,
                  extra3: false
                }
              }
              this.HogansDataCustomer.push(clientPhoto);
            });
          })
          .then(() => {
             // Alle before foto's binnenhalen en kijken of hier afters bij horen
            let allDataBefore = db.collection("clientphotos")
              .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
              .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
              .where("company", "==", this.dataFilter.activeComp)     
              .where("photoBA", "==", 0)
              .orderBy("datePhoto", "asc");
            let branchDataBefore = db.collection("clientphotos")
                .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
                .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
                .where("company", "==", this.dataFilter.activeComp)     
                .where("photoBA", "==", 0)
                .where("branch", "==", this.dataFilter.selectedBranch)
                .orderBy("datePhoto", "asc");
            let branchFilterBefore = this.dataFilter.selectedBranch == 'all' ? allDataBefore : branchDataBefore;

              branchFilterBefore.get()
              .then(snapshot => {
                snapshot.forEach(doc => {
                 let matchingAfterIndex =   _.findIndex(this.HogansDataCustomer, { 'salonhub_ID': doc.data().salonhub_ID })
                 // console.log("matchingAfterIndex: ", matchingAfterIndex, doc.data().salonhub_ID)

                 if(matchingAfterIndex >= 0){
                  // console.log("matchingAfterIndex: ", matchingAfterIndex) 
                  this.HogansDataCustomer[matchingAfterIndex].beforeId = doc.id
                  this.HogansDataCustomer[matchingAfterIndex].photoCollectionBefore = doc.data().photoCollection;
                  this.HogansDataCustomer[matchingAfterIndex].photoCollectionBefore = doc.data().photoCollection;
                  this.HogansDataCustomer[matchingAfterIndex].socialmediaBefore = doc.data().socialmedia;
                  if(doc.data().mailing){
                    this.HogansDataCustomer[matchingAfterIndex].mailingBefore = doc.data().mailing;
                  }
                  else{
                    this.HogansDataCustomer[matchingAfterIndex].mailingBefore = {
                      front: false,
                      side: false,
                      back: false,
                      extra: false,
                      extra2: false,
                      extra3: false
                    }
                  }
                 } 
                 else{
                   let clientPhoto = doc.data();
                    clientPhoto.id = doc.id;
                    clientPhoto.beforeId = doc.id;
                    clientPhoto.photoCollectionBefore = doc.data().photoCollection;
                    clientPhoto.socialmediaBefore = doc.data().socialmedia;
                    clientPhoto.photoCollection = null;
                    // clientPhoto.socialmedia = null;
                    if(clientPhoto.mailing){
                      clientPhoto.mailingBefore = clientPhoto.mailing;
                    }
                    else{
                      clientPhoto.mailingBefore = {
                        front: false,
                        side: false,
                        back: false,
                        extra: false,
                        extra2: false,
                        extra3: false
                      }
                    }
                    this.HogansDataCustomer.push(clientPhoto);
                 }
                })
              })
              .then(()=>{
                let allDataControle = db.collection("clientphotos")
                  .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
                  .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
                  .where("company", "==", this.dataFilter.activeComp)     
                  .where("photoBA", "==", 2)
                  .orderBy("datePhoto", "asc");
                let branchDataControle = db.collection("clientphotos")
                    .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
                    .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
                    .where("company", "==", this.dataFilter.activeComp)     
                    .where("photoBA", "==", 2)
                    .where("branch", "==", this.dataFilter.selectedBranch)
                    .orderBy("datePhoto", "asc");
                let branchFilterControle = this.dataFilter.selectedBranch == 'all' ? allDataControle : branchDataControle;

                branchFilterControle.get()
                .then(snapshot => {
                  snapshot.forEach(doc => {
                  let matchingAfterIndex =   _.findIndex(this.HogansDataCustomer, { 'salonhub_ID': doc.data().salonhub_ID })
                  // console.log("matchingAfterIndex: ", matchingAfterIndex, doc.data().salonhub_ID)

                  if(matchingAfterIndex >= 0){
                    // console.log("matchingAfterIndex: ", matchingAfterIndex)
                    this.HogansDataCustomer[matchingAfterIndex].checkupId = doc.id;
                    if(this.HogansDataCustomer[matchingAfterIndex].photoCollectionCheckup){
                      this.HogansDataCustomer[matchingAfterIndex].photoCollectionCheckupTwo = doc.data().photoCollection;
                    }
                    else{
                      this.HogansDataCustomer[matchingAfterIndex].photoCollectionCheckup = doc.data().photoCollection;
                    }

                    
                    this.HogansDataCustomer[matchingAfterIndex].socialmediaCheckup = doc.data().socialmedia;


                    if(doc.data().mailing){
                      this.HogansDataCustomer[matchingAfterIndex].mailingCheckup = doc.data().mailing;
                    }
                    else{
                      this.HogansDataCustomer[matchingAfterIndex].mailingCheckup = {
                        front: false,
                        side: false,
                        back: false,
                        extra: false,
                        extra2: false,
                        extra3: false
                      }
                    }
                  } 
                  else{
                    let clientPhoto = doc.data()
                      clientPhoto.id = doc.id;
                      clientPhoto.checkupId = doc.id;
                      clientPhoto.photoCollectionCheckup = doc.data().photoCollection;
                      clientPhoto.socialmediaCheckup = doc.data().socialmedia;
                      clientPhoto.photoCollection = null;
                      // clientPhoto.socialmedia = null;
                      if(clientPhoto.mailing){
                        clientPhoto.mailingCheckup = clientPhoto.mailing;
                      }
                      else{
                        clientPhoto.mailingCheckup = {
                          front: false,
                          side: false,
                          back: false,
                          extra: false,
                          extra2: false,
                          extra3: false
                        }
                      }
                      this.HogansDataCustomer.push(clientPhoto);
                    }
                  })
                })
                .then(()=>{
                  this.loading = false;
                  this.loadingError = null;
                })
              })
          })
          .catch(error => {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            this.loading = false;
            this.loadingError = true;
          });

      }
      else {
        // filterPosted is "showAll" maar "Posted" of "NotPosted"
        let photoPosted = true

        if (this.filterPosted == "notposted") {
          photoPosted = false;
        }

        let allDataAfter = db.collection("clientphotos")
          .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
          .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
          .where("company", "==", this.dataFilter.activeComp)
          .where("socialposted", "==", photoPosted)     
          .where("photoBA", "==", 1)
          .orderBy("datePhoto", "asc");
        let branchDataAfter = db.collection("clientphotos")
            .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").format("YYYY-MM-DD"))
            .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
            .where("company", "==", this.dataFilter.activeComp)  
            .where("socialposted", "==", photoPosted)   
            .where("photoBA", "==", 1)
            .where("branch", "==", this.dataFilter.selectedBranch)
            .orderBy("datePhoto", "asc");
        let branchFilterAfter = this.dataFilter.selectedBranch == 'all' ? allDataAfter : branchDataAfter;


          // Alle after foto's binnenhalen
          branchFilterAfter.get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let clientPhoto = doc.data()
              clientPhoto.id = doc.id
              clientPhoto.photoCollectionBefore = null
              clientPhoto.socialmediaBefore = null
              this.HogansDataCustomer.push(clientPhoto);
            });
          })
          .then(() => {
             // Alle before foto's binnenhalen en kijken of hier afters bij horen
            db.collection("clientphotos")
              .where("datePhoto",">", moment(this.dataFilter.chosenDateCalendar).startOf("month").subtract(1, 'days').format("YYYY-MM-DD"))
              .where("datePhoto", "<", moment(this.dataFilter.chosenDateCalendar).endOf("month").add(1, 'days').format("YYYY-MM-DD"))
              .where("company", "==", this.dataFilter.activeComp)
              .where("photoBA", "==", 0)
              .orderBy("datePhoto", "asc")
              .get()
              .then(snapshot => {
                snapshot.forEach(doc => {
                 let matchingAfterIndex =   _.findIndex(this.HogansDataCustomer, { 'salonhub_ID': doc.data().salonhub_ID })

                 if(matchingAfterIndex >= 0){
                  //console.log("matchingAfterIndex: ", matchingAfterIndex)
                  this.HogansDataCustomer[matchingAfterIndex].photoCollectionBefore = doc.data().photoCollection
                  this.HogansDataCustomer[matchingAfterIndex].socialmediaBefore = doc.data().socialmedia
                 }
                 else{
                   let clientPhoto = doc.data()
                    clientPhoto.id = doc.id
                    clientPhoto.photoCollectionBefore = doc.data().photoCollection
                    clientPhoto.socialmediaBefore = doc.data().socialmedia
                    clientPhoto.photoCollection = null
                    clientPhoto.socialmedia = null
                    this.HogansDataCustomer.push(clientPhoto);
                 }
                })
              })
              .then(()=>{
                this.loading = false;
                this.loadingError = null;
              })
          })
          .catch(error => {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            this.loading = false;
            this.loadingError = true;
          });

      }

      // db.collection("clientphotos")
      //   .where("datePhoto", ">=", this.today)
      //   .orderBy("datePhoto", "desc")
      //   .limit(1)
      //   // .where(`branch`, "==", this.activeBranch) //Dynamisch maken
      //   .onSnapshot(querySnapshot => {
      //     querySnapshot.forEach(doc => {
      //       setTimeout(() => {
      //         this.HogansDataCustomer.push({
      //           id: doc.id,
      //           salonhub_ID: doc.data().salonhub_ID,
      //           datePhoto: doc.data().datePhoto,
      //           photoCollection: doc.data().photoCollection,
      //           branchName: doc.data().branchName,
      //           customerName: doc.data().customerName,
      //           companyName: doc.data().companyName,
      //           socialmedia: doc.data().socialmedia
      //         });
      //       }, 20000);
      //     });
      //   });

      // deletePicture(){
      //       let selectedImage = this.selectedImage
      //       this.pictureDetailsFeedback = null,
      //       this.deletingImage = true
      //       console.log("Start delete function");
      //       if(this.pictures[selectedImage].imageUrl){
      //         console.log("Image found");
      //         let storageThumbRefFromURL = null
      //         let filePathThumb
      //         let storage = firebase.storage();
      //         let storageRefFromURL = storage.refFromURL(this.pictures[selectedImage].imageUrl)
      //         let filePath = storageRefFromURL.location.path
      //         let storageRef = storage.ref();

      //         if(this.pictures[this.selectedImage].imageThumbUrl){
      //           storageThumbRefFromURL = storage.refFromURL(this.pictures[selectedImage].imageThumbUrl)
      //           filePathThumb = storageThumbRefFromURL.location.path
      //           storageRef.child(filePathThumb).delete()
      //         }
      //         console.log("this.pictures.length: ", this.pictures.length);

      //         if(this.pictures.length > 1 && this.selectedImage == this.pictures.length - 1){
      //           this.selectedImage = this.pictures.length - 2
      //         } else if(this.pictures.length == 1) {
      //           this.selectedImage = 0
      //         }

      //         console.log("this.selectedImage: ", this.selectedImage);

      //         storageRef.child(filePath).delete()
      //           .then(()=> {
      //             console.log("Image successfull deleted from storage");
      //             db.collection("bodypictures").doc(this.pictures[selectedImage].id).delete()
      //             .then(()=> {

      //               console.log("Document bodypictures successfull deleted");
      //               this.pictures.splice(this.selectedImage, 1)
      //               this.deleteSelectedPictureDialog = false
      //               this.deletingImage = false
      //               this.closePictureDetails()
      //             })
      //             .then(()=>{
      //               this.$toasted.global.success({
      //                 message : "Foto is succesvol verwijderd"
      //               }).goAway(2000)
      //           })
      //             .catch(error=> {
      //               console.error("Error deleting bodypictures document");
      //               this.deleteSelectedPictureDialog = false
      //               this.deletingImage = false
      //               this.pictureDetailsFeedback = "Verwijderen van de foto is niet gelukt."
      //             });
      //           })
      //           .catch(error=> {
      //             console.error("Error deleting the image from storage");
      //             this.deleteSelectedPictureDialog = false
      //             this.deletingImage = false
      //             this.pictureDetailsFeedback = "Verwijderen van de foto is niet gelukt."
      //           });
      //         }
      //         else {
      //           console.log("No image found");
      //           db.collection("bodypictures").doc(this.pictures[selectedImage].id).delete()
      //           .then(()=> {
      //             console.log("Document bodypictures successfull deleted");
      //             this.pictures.splice(this.selectedImage, 1)
      //             this.deleteSelectedPictureDialog = false
      //             this.deletingImage = false
      //             this.closePictureDetails()
      //           })
      //           .then(()=>{
      //             this.$toasted.global.success({
      //               message : "Foto is succesvol verwijderd"
      //             }).goAway(2000)
      //           })
      //           .catch(error=> {
      //             console.error("Error deleting bodypictures document");
      //             this.deleteSelectedPictureDialog = false
      //             this.deletingImage = false
      //             this.pictureDetailsFeedback = "Verwijderen van de foto is niet gelukt."
      //           });
      //         }
      //     },
    },
     socialStatusPhotos(status){
      if(status == true){
        return "Gepost"
      } else{
        return "Niet gepost"
      }
    },

    mailingCheckUpStatus(photos){
      if(photos.mailingCheckUpDone){
        return "Foto's gecontroleerd"
      } else{
        return "Foto's niet gecontroleerd"
      }
    },

    /** 
     * @item { Object } Firebase object with all data
     * @collectionType {string} example = 'photoCollectionCheckup'
     * @positionType {string} example = 'font'
    */ 
      
    deleteIndividualPhoto(item, collectionType, positionType){
      let storage = firebase.storage();
      let storageRef = storage.ref();
      let storageRefFromURL = storage.refFromURL(item[collectionType][positionType]);
      let storageRefThumbFromURL = storage.refFromURL(item[collectionType][`${positionType}_thumb`]);
      let filePath = storageRefFromURL.location.path;
      let filePathThumb = storageRefThumbFromURL.location.path;
      storageRef.child(filePath).delete()
      storageRef.child(filePathThumb).delete()
      item[collectionType][positionType] = null;
      item[collectionType][`${positionType}_thumb`] = null;
      db.collection("clientphotos").doc(item.id).set({
        [collectionType] : item[collectionType]
      },{merge: true}) 
    },

    deletePhoto(photoid) {
      this.HogansDataCustomer.forEach(o => {
        if (photoid == o.id) {
          console.log(this.HogansDataCustomer.indexOf(o));

          this.HogansDataCustomer.splice(this.HogansDataCustomer.indexOf(o), 1);

          db.collection("clientphotos")
            .doc(photoid)
            .delete()
            .then(() => {
              console.log("Document  client photo successfull deleted");
            })

            .catch(error => {
              console.error("Error deleting bodypictures document");
            });

          // // Orgineel
          // let storage = firebase.storage();
          // let storageRefFromURL = storage.refFromURL(o.photoCollection.back);
          // let filePath = storageRefFromURL.location.path;
          // let storageRef = storage.ref();
          // console.log(storageRef.child(filePath));
          // storageRef
          //   .child(filePath)
          //   .delete()
          //   .then(() => {
          //     console.log("Image successfull deleted from storage");
          //     storageRefFromURL = storage.refFromURL(o.photoCollection.front);
          //     filePath = storageRefFromURL.location.path;
          //     storageRef = storage.ref();
          //     console.log(storageRef.child(filePath));
          //   });

          // Photo Back
          let storage_back = firebase.storage();
          let storageRefFromURL_back = storage_back.refFromURL(
            o.photoCollection.back
          );
          let filePath_back = storageRefFromURL_back.location.path;
          let storageRef_back = storage_back.ref();

          storageRef_back
            .child(filePath_back)
            .delete()
            .then(() => {
              console.log("Photo Back successfull deleted from storage");
              storage_back = firebase.storage();
              storageRefFromURL_back = storage_back.refFromURL(
                o.photoCollection.back_thumb
              );
              filePath_back = storageRefFromURL_back.location.path;
              storageRef_back = storage_back.ref();

              storageRef_back
                .child(filePath_back)
                .delete()
                .then(() => {
                  console.log(
                    "Photo back thumb successfull deleted from storage"
                  );
                });
            });

          // Photo Front
          let storage_front = firebase.storage();
          let storageRefFromURL_front = storage_front.refFromURL(
            o.photoCollection.front
          );
          let filePath_front = storageRefFromURL_front.location.path;
          let storageRef_front = storage_front.ref();

          storageRef_front
            .child(filePath_front)
            .delete()
            .then(() => {
              console.log("Photo front successfull deleted from storage");
              storage_front = firebase.storage();
              storageRefFromURL_front = storage_front.refFromURL(
                o.photoCollection.front_thumb
              );
              filePath_front = storageRefFromURL_front.location.path;
              storageRef_front = storage_front.ref();

              storageRef_front
                .child(filePath_front)
                .delete()
                .then(() => {
                  console.log(
                    "Photo front thumb successfull deleted from storage"
                  );
                });
            });

          // Photo Side
          let storage_side = firebase.storage();
          let storageRefFromURL_side = storage_side.refFromURL(
            o.photoCollection.side
          );
          let filePath_side = storageRefFromURL_side.location.path;
          let storageRef_side = storage_side.ref();

          storageRef_side
            .child(filePath_side)
            .delete()
            .then(() => {
              console.log("Photo side successfull deleted from storage");
              storage_side = firebase.storage();
              storageRefFromURL_side = storage_side.refFromURL(
                o.photoCollection.side_thumb
              );
              filePath_side = storageRefFromURL_side.location.path;
              storageRef_side = storage_side.ref();

              storageRef_side
                .child(filePath_side)
                .delete()
                .then(() => {
                  console.log(
                    "Photo side thumb successfull deleted from storage"
                  );
                });
            });

          //Checkt of er een extra foto aanwezig is
          if (o.photoCollection.extra !== null) {
            // Photo Side
            let storage_extra = firebase.storage();
            let storageRefFromURL_extra = storage_extra.refFromURL(
              o.photoCollection.extra
            );
            let filePath_extra = storageRefFromURL_extra.location.path;
            let storageRef_extra = storage_extra.ref();
            console.log(storageRef.child(filePath_extra));
            storageRef_extra
              .child(filePath_extra)
              .delete()
              .then(() => {
                console.log("Photo extra successfull deleted from storage");
                storage_extra = firebase.storage();
                storageRefFromURL_extra = storage_extra.refFromURL(
                  o.photoCollection.extra_thumb
                );
                filePath_extra = storageRefFromURL_extra.location.path;
                storageRef_extra = storage_extra.ref();

                storageRef_extra
                  .child(filePath_extra)
                  .delete()
                  .then(() => {
                    console.log(
                      "Photo extra thumb successfull deleted from storage"
                    );
                  });
              });
          }
        }
      });

      // let storage = firebase.storage();
      //   let storageRefFromURL = storage.refFromURL()
      //   let filePath = storageRefFromURL.location.path
      //   let storageRef = storage.ref();
    }
  },

  computed: {
    photoPageCountResults(){
      return Math.ceil(this.HogansDataCustomerSorted.length / 15);
    },

    filteredFotosPosted(){
      let counterPosted = 0
      this.HogansDataCustomer.forEach(item=>{
        if(item.socialposted == true){
          counterPosted++
        }
      })
      return counterPosted
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
    filteredFotosAfter(){
      let counterAfter = 0
      this.HogansDataCustomer.forEach(item=>{
        if(item.photoCollection){
          counterAfter++
        }
      })
      return counterAfter
    },
    filteredFotosBefore(){
      let counterBefore = 0
      this.HogansDataCustomer.forEach(item=>{
        if(item.photoCollectionBefore){
          counterBefore++
        }
      })
      return counterBefore
    },

    filteredFotos(){
      return this.HogansDataCustomerBefore.length + this.HogansDataCustomer.length
    },

    socialStatus() {
      if (this.userRole == "superadmin" || this.userRole == "admin") {
        return false;
      } else {
        return true;
      }
    },

    HogansDataCustomerSorted(){
      // return this.HogansDataCustomer.slice().reverse() 
      return _.orderBy(this.HogansDataCustomer,  ['datePhoto'], ['desc']);
    },

    HogansDataCustomerSortedPages(){
      let pagedItems = new Array();
      this.HogansDataCustomerSorted.forEach((item, index)=>{
        if(index <=  ((this.photoResultsPage * 15) -1) && index >=  ((this.photoResultsPage * 15)-15)){
          pagedItems.push(item)
        }
      })
      return pagedItems
    },


    demoMode(){
      return this.$store.state.demoMode;
    },
    
    loginError() {
      return this.$store.state.error;
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    filterGridClass(){
      if(this.userCompanies.length > 1 && !this.demoMode){
        return "md3"
      } else {
        return "md3"
      }
    },

    chosenDateCalendarFormated(){
      let chosenMonth = moment(this.dataFilter.chosenDateCalendar).format("MMMM YYYY")
      return String(chosenMonth).charAt(0).toUpperCase() + String(chosenMonth).slice(1);
    },

    filterChanged() {
      if (_.isEqual(this.dataFilter, this.dataFilterSaved) == false) {
        return false;
      } else {
        return true;
      }
    },
  }
};
</script>

<style scoped>
.photo-collection-wrapper {
  margin: 25px 0;
}

.photobox{
  position: relative;
}
/* Icons */

.photodate {
  margin: 4px 0;
  font-size: 14px !important;
}

.deleteicon {
  background: url("../assets/icons/bin-icon-grey.svg") no-repeat center center;
  background-size: 26px auto;
  margin-left: 0px;
  margin-top: 12px;
}

.shareicon {
  background: url("../assets/icons/share-icon.svg") no-repeat center center;
  background-size: 26px auto;
}

.download-overlay {
  display: none;
  position: absolute;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  padding: 0 20px;
  z-index: 8;
  background-color: rgba(0, 0, 0, 0.3);
}

.download {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 8;
}

.download:hover .download-overlay {
  display: block;
}

.socialapproved {
  background: url("../assets/icons/share-button.svg") no-repeat center center;
  height: 34px; 
  width: 34px; 
  background-position-x: 4px; 
  background-size: 24px; 
  border-radius: 30px;
  margin: 8px;
  position: absolute;
  z-index: 8;
}

.shadowtext {
  text-shadow: 1px 1px 3px #000;
}

.photo-download-button{
  position: absolute;
  top: calc(50% - 10px);
  margin: 0 auto;
  display: block;
  width: calc(100% - 40px);
}

span.BeforeAfter {
  margin: 0 0 0 2px;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 6px 4px 6px 4px;
  border-radius: 5px;
  color: white;
  position: absolute;
  bottom: 12px;
  font-size: 14px;
}

.individual-remove-photo{
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 99;
}
.photobox{
  position: relative;
}


</style>
